export const deleteRouteMapping = (builder) => ({
    deleteRouteMapping: builder.mutation({
        query: (body) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/remove_route_from_enterpriseuser',
                method: 'DELETE',
                body: body,
                headers: {
                  'Content-Type': 'application/json',
                  'Authorization': token
                },
              };
        },
    }),
});
